module.exports = __webpack_public_path__ + "img/fb7bb42.png";